(() => {
  angular
    .module('app')
    .controller(
      'host.views.corporates.createEdit.collateral.collateralAdd',
      CollateralAddModalController
    );

  CollateralAddModalController.$inject = [
    '$uibModalInstance',
    'moment',
    'appConstants',
    'abp.services.app.collateralEpisode',
    'abp.services.app.commonLookup',
    'Hms.MultiTenancy.CollateralType',
    'corporateId',
    'currencyCode',
    'countryCode',
  ];

  function CollateralAddModalController(
    $uibModalInstance,
    moment,
    appConstants,
    collateralEpisodeSvc,
    commonLookupSvc,
    enumCollateralType,
    corporateId,
    currencyCode,
    countryCode
  ) {
    const vm = this;

    // Matches CollateralEpisode.MaxDocumentSizeInBytes on the server.

    const maxDocumentSizeInMb = 10;
    const pdfExtensions = `|${appConstants.fileUpload.pdfExtensions.join('|')}|`;

    vm.loading = 0;
    vm.saving = 0;
    vm.currencyCode = currencyCode;
    vm.maxDocumentSizeInMb = maxDocumentSizeInMb;

    vm.enums = {
      collateralType: enumCollateralType,
    };

    // Type selector buttons, in display order.

    vm.collateralTypes = [
      enumCollateralType.Escrow,
      enumCollateralType.DirectDebit,
      enumCollateralType.BankGuarantee,
    ];

    vm.input = {
      collateralType: enumCollateralType.Escrow.id,
      amount: null,
      inputDate: null,
      guaranteeReferenceNumber: '',
      issuingBankId: null,
      issueDate: null,
      expiryDate: null,
      remarks: '',
    };

    // The Bank Guarantee PDF. Uploaded to Temp first; the server promotes it on save.

    vm.newAttachments = [];
    vm.uploadConfig = {
      objectType: 'CollateralBankGuaranteeDocument',
      itemsLimit: 1,
      accept: 'application/pdf',
      filters: [
        {
          name: 'fileFilter',
          fn(n) {
            const t = `|${n.type.slice(n.type.lastIndexOf('/') + 1)}|`;
            if (pdfExtensions.indexOf(t) === -1) {
              abp.message.warn(App.localize('Collateral_DocumentMustBePdf'));
              return false;
            }
            return true;
          },
        },
        {
          name: 'sizeFilter',
          fn(n) {
            const sizeLimit = maxDocumentSizeInMb * 1024 * 1024;
            if (n.size > sizeLimit) {
              abp.message.warn(App.localize('Collateral_DocumentTooLarge', maxDocumentSizeInMb));
              return false;
            }
            return true;
          },
        },
      ],
    };

    vm.selectType = selectType;
    vm.isBankGuarantee = isBankGuarantee;
    vm.save = save;
    vm.cancel = cancel;

    init();

    function init() {
      getBanks();
    }

    // Issuing banks are limited to the corporate's country.

    function getBanks() {
      vm.loading += 1;
      commonLookupSvc
        .getBanks()
        .success((data) => {
          vm.banksByCountryCode = _.filter(data.items, (b) => b.countryCode === countryCode);
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function selectType(collateralType) {
      vm.input.collateralType = collateralType;
    }

    function isBankGuarantee() {
      return vm.input.collateralType === enumCollateralType.BankGuarantee.id;
    }

    // Client-side checks mirror the server rules; the server remains the authority.

    function save() {
      // Enter can submit the form while a save is still running.
      if (vm.saving) return;

      if (!App.isFormValid(vm.collateralAddForm)) {
        abp.notify.error(App.localize('GeneralInvalidFormInputError'));
        return;
      }

      if (isBankGuarantee() && !vm.newAttachments.length) {
        abp.notify.error(App.localize('Collateral_DocumentRequired'));
        return;
      }

      vm.saving += 1;
      collateralEpisodeSvc
        .createCollateralEpisode(getPayload())
        .success(() => {
          abp.notify.success(App.localize('Collateral_Added'));
          $uibModalInstance.close(true);
        })
        .finally(() => {
          vm.saving -= 1;
        });
    }

    // Send only the fields that belong to the chosen collateral type.

    function getPayload() {
      const payload = {
        corporateId,
        collateralType: vm.input.collateralType,
        amount: vm.input.amount,
        remarks: vm.input.remarks,
      };

      if (isBankGuarantee()) {
        const attachment = vm.newAttachments[0];
        _.extend(payload, {
          guaranteeReferenceNumber: vm.input.guaranteeReferenceNumber,
          issuingBankId: vm.input.issuingBankId,
          issueDate: getDateString(vm.input.issueDate),
          expiryDate: getDateString(vm.input.expiryDate),
          document: {
            fileName: attachment.fileName,
            originalFileName: attachment.originalFileName,
          },
        });
      } else {
        payload.inputDate = getDateString(vm.input.inputDate);
      }

      return payload;
    }

    // Send dates as date-only strings so no time zone shift can move the day.

    function getDateString(date) {
      return moment(date).format('YYYY-MM-DD');
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
